import { useState } from "react";
import { StepWizard } from "../components/StepWizard";
import { portfolioWizardTypes, wizardStepsDefinitionEconDispatch } from "../models/wizardStepsDefinition";
import { Container, VStack } from "@chakra-ui/react";
import { StepDisplayModel, StepStateModel } from "../models/StepModel";
import { SelectWizardType } from "./SelectWizardType";

interface StepWizardDisplayState {
    tracker: 'steps' | 'percent',
    orientation: 'horizontal' | 'vertical',
    colorScheme: 'red' | 'orange' | 'yellow' | 'green' | 'blue'
}

export interface WizardContainerProps {
    wizardTitle: string,
    onFinish: (progress: StepStateModel[]) => Promise<void>,
    onExitWithoutSaving: () => void,
}

const WizardContainer = (props: WizardContainerProps) => {
    const { wizardTitle,
        onFinish, 
        onExitWithoutSaving
    } = props;

    const [displayState, setDisplayState] = useState<StepWizardDisplayState>({ 
        tracker: 'percent', 
        orientation: 'horizontal',
        colorScheme: 'blue'
    });
    const selectedWizardOptionValue = 'EconDispatch'; // default to "Econ Dispatch"
    //const wizardStepsDefinitionEconDispatch: StepDisplayModel[]
    const [selectedWizardType, setSelectedWizardType] = useState<StepDisplayModel[] | null>(null); // to track the selected wizard type
    const wizardTypeLabel = portfolioWizardTypes.find((type) => type.optionValue === selectedWizardOptionValue)?.label;

    return (

        <Container maxW={'6xl'}>
            <VStack py={5} spacing={5}>
                <h3>{wizardTitle} - {wizardTypeLabel}</h3>
            </VStack>

            {!selectedWizardType && 
                <SelectWizardType 
                    saveActiveStepState={function (activeStep: number, progress: StepStateModel): void {
                        setSelectedWizardType(wizardStepsDefinitionEconDispatch); // set the selected wizard type to the econ dispatch steps
                    } }
                    stepsSavedState={[]}
                    title={"TypeStep"}
                    stepIdx={-1}
                    selectedStepOptionValue={selectedWizardOptionValue} // default to "Econ Dispatch"
                    stepOptions={portfolioWizardTypes} 
                    setIsStepValid={function (isValid: boolean): void {
                        // Perform any necessary actions here, but do not return a value
                    } }               
                />
            }

            {selectedWizardType && 
                <StepWizard
                    tracker={displayState.tracker} 
                    orientation={displayState.orientation} 
                    colorScheme={displayState.colorScheme}
                    wizardSteps={selectedWizardType}
                    onExitWithoutSaving={onExitWithoutSaving}
                    onFinish={async (progress: StepStateModel[]) => {
                        console.log(`Finished at WizardContainer ${[...progress]} ... save to database and redirect to newly created portfolio`);
                        await onFinish(progress);
                    }}
                />
            }   
        </Container>

    );
}

export default WizardContainer;
